









import { Component, Prop, Vue } from 'vue-property-decorator'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import Color from 'color'

@Component
export default class PipelinePhaseLabel extends Vue {
    @Prop({ required: true }) readonly phase!: PipelinePhase

    get classAttribute(): string[] {
        return [
            'block',
            'text-xs',
            'p-3',
            'rounded',
        ]
    }

    get styleAttribute() {
        return {
            backgroundColor: this.backgroundColor,
            color: this.foregroundColor,
        }
    }

    get backgroundColor(): Color {
        return Color(this.phase.color)
    }

    get foregroundColor(): Color {
        return Color('white').alpha(0.9)
    }
}
